import { PageHero, Reveal } from "../components/Reveal";
import ShowroomCard, { FutureCategoryCard } from "../components/ShowroomCard";
import { NextPaths } from "../components/DivisionCards";
import { DIVISIONS } from "../data/site";
import useSeo from "../components/Seo";

// Generic division showroom — renders any division from the DIVISIONS catalogue (data/site.js).
export default function DivisionPage({ slug }) {
  const division = DIVISIONS.find((d) => d.slug === slug);
  const prefix = division.testPrefix;
  useSeo(division.title, `${division.desc} — The Royal Mahaveer Roadlines Pvt Ltd.`);
  return (
    <>
      <PageHero
        overline={`Division ${division.letter} — ${division.title}`}
        lines={[
          <>{division.hero.line1}</>,
          <><em className="italic text-gold-light">{division.hero.em}</em>{division.hero.line2 ? ` ${division.hero.line2}` : ""}</>,
        ]}
        desc={division.heroDesc}
      />

      <section className="py-24 sm:py-32" data-testid={`${prefix}-showroom-section`}>
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <Reveal>
            <p className="max-w-3xl border border-gold/15 bg-surface px-6 py-5 text-xs leading-relaxed text-foreground/75" data-testid={`${prefix}-image-note`}>
              Images marked <span className="font-semibold text-gold">OUR FLEET</span> are photographs of our own vehicles.
              Images marked <span className="font-semibold text-foreground/80">REPRESENTATIVE IMAGE</span> illustrate the
              vehicle category only and are not presented as our fleet.
              {division.note && <> <span className="font-semibold text-gold">Please note:</span> {division.note}</>}
            </p>
          </Reveal>
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:gap-8" data-testid={`${prefix}-category-grid`}>
            {division.categories.map((c, i) => (
              <ShowroomCard key={c.title} item={c} index={i} testId={`${prefix}-card-${i}`} />
            ))}
            <FutureCategoryCard testId={`${prefix}-future-card`} />
          </div>
        </div>
      </section>

      <NextPaths exclude={`/${division.slug}`} />
    </>
  );
}
